(ns ui.view.transaction-process.modals.declaration.sub
  (:require
   [re-frame.core :as rf]
   [ui.view.transaction-process.modals.common :as common]
   [ui.view.transaction-process.sub :as tp-sub]
   [ui.view.transaction-process.util :as tp-util]))

(rf/reg-sub
 ::form
 (fn [db [_ {:keys [state-path] :as _ctx}]]
   (get-in db (common/form-full-path state-path))))

(rf/reg-sub
 ::edit-mode?
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:edit-mode? form)))

(rf/reg-sub
 ::submitting?
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:submitting? form)))

(rf/reg-sub
 ::error
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:error form)))

(rf/reg-sub
 ::type-label
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:declaration-type-label form)))

(rf/reg-sub
 ::date
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:declaration/date form)))

(rf/reg-sub
 ::comment
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]] (:declaration/comment form)))

(rf/reg-sub
 ::status
 (fn [[_ ctx]] [(rf/subscribe [::form ctx])])
 (fn [[form]]
   (tp-util/flags->declaration-status
    {:not-applicable? (:declaration/not-applicable? form)
     :completed?      (:declaration/completed? form)})))

(rf/reg-sub
 ::entry
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/template ctx])])
 (fn [[form template]]
   (tp-util/dictionary-entry template (:slot-kw form))))

(rf/reg-sub
 ::slot-template
 (fn [[_ ctx]] [(rf/subscribe [::entry ctx])])
 (fn [[entry]] (:slot/template entry)))

(rf/reg-sub
 ::field-configs
 (fn [[_ ctx]] [(rf/subscribe [::tp-sub/template ctx])])
 (fn [[template]] (:template/fields template)))

(rf/reg-sub
 ::mandatory-fields
 ;; Currently-mandatory field-kws derived from the template field-configs over the
 ;; slot template's value-fields (e.g. :declaration/date flips on once Completed).
 ;; Single source for the modal asterisks; agrees with ::ready-errors, which walks
 ;; the same configs.
 (fn [[_ ctx]]
   [(rf/subscribe [::slot-template ctx])
    (rf/subscribe [::field-configs ctx])
    (rf/subscribe [::form ctx])
    (rf/subscribe [::tp-sub/process ctx])])
 (fn [[slot-template field-configs form process]]
   (->> (tp-util/template-value-fields slot-template)
        (filter #(tp-util/field-mandatory? (get field-configs %) (merge process form)))
        set)))

(rf/reg-sub
 ::ready-errors
 (fn [[_ ctx]]
   [(rf/subscribe [::form ctx])
    (rf/subscribe [::slot-template ctx])
    (rf/subscribe [::field-configs ctx])
    (rf/subscribe [::tp-sub/process ctx])])
 (fn [[form slot-template field-configs process]]
   (tp-util/declaration-ready-errors
    {:field-configs field-configs
     :slot-template slot-template
     :values        form
     :process       process})))
